export default "__VITE_ASSET__ea941471__"